import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, MaintenanceDto, MaintenanceReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import MaintenanceInline from "./MaintenanceInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: MaintenanceDto | MaintenanceReferenceDto | null | undefined;
  entityId?: string | null;
}

export default function MaintenanceLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.MaintenanceRead]}
      to={ROUTE_PATH.MAINTENANCE_VIEW(entity?.id || entityId || "")}
      content={<MaintenanceInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
